/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import dayjs from "dayjs";
import styled from "styled-components";
import { theme, Text, Tooltip, SVGIcon, Spacer } from "@nordcloud/gnui";
import { FlexContainer } from "~/components";
import { IconWrap } from "~/components/Navbar/UserDropdown";
import { dateFormatWithHours } from "~/constants";
import { Customer } from "./types";

const StyledWrapper = styled(FlexContainer)`
  margin-bottom: ${theme.spacing.spacing04};
`;

type HistoryOfEditingProps = {
  customer: Customer;
};

function HistoryOfEditing({ customer }: HistoryOfEditingProps) {
  return (
    <StyledWrapper>
      <Tooltip
        caption={
          <>
            <FlexContainer>
              <Text size="sm" mb={0} mr={theme.spacing.spacing01}>
                Created:
              </Text>
              <Text size="sm" weight="medium" mb={0}>
                {dayjs(customer?.log?.created?.time).format(
                  `${dateFormatWithHours}`
                )}
              </Text>
            </FlexContainer>
            <FlexContainer>
              <Text size="sm" mb={0} mr={theme.spacing.spacing01}>
                By:
              </Text>
              <Text
                size="sm"
                weight="medium"
                mb={0}
                mr={theme.spacing.spacing01}
              >
                {customer?.log?.created?.author}
              </Text>
            </FlexContainer>
            <Spacer height={theme.spacing.spacing04} />
            <FlexContainer>
              <Text size="sm" mb={0} mr={theme.spacing.spacing01}>
                Modified:
              </Text>
              <Text
                size="sm"
                weight="medium"
                mb={0}
                mr={theme.spacing.spacing01}
              >
                {dayjs(customer?.log?.modified?.time).format(
                  `${dateFormatWithHours}`
                )}
              </Text>
            </FlexContainer>
            <FlexContainer>
              <Text size="sm" mb={0} mr={theme.spacing.spacing01}>
                By:
              </Text>
              <Text
                size="sm"
                weight="medium"
                mb={0}
                mr={theme.spacing.spacing01}
              >
                {customer?.log?.modified?.author}
              </Text>
            </FlexContainer>
          </>
        }
        status="notification"
      >
        <FlexContainer>
          <Text
            size="sm"
            color={theme.color.text.text02}
            m={0}
            mr={theme.spacing.spacing01}
          >
            Last modified:
          </Text>
          <Text
            size="sm"
            color={theme.color.text.text02}
            m={0}
            weight="medium"
            mr={theme.spacing.spacing01}
          >
            {dayjs(customer?.log?.modified?.time).format(
              `${dateFormatWithHours}`
            )}
          </Text>
          <IconWrap>
            <SVGIcon size="sm" name="info" />
          </IconWrap>
        </FlexContainer>
      </Tooltip>
    </StyledWrapper>
  );
}

export { HistoryOfEditing };
